import styled from './listaultimospedidos.module.css';
import api from '../../services/api';
import { useContext, useEffect, useState } from 'react';
import { Alerta } from '../../utils/functions';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../services/global';
import { Loader } from '../Loader';


function ListaUltimosPedidos(props) {
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    const [pedidos, setPedidos] = useState([]);
    const [datas, setDatas] = useState([]);
    const { setDadosPed } = useContext(AuthContext);
    const [isLoading, setLoading] = useState(false);

    const Navigate = useNavigate('');

    function DetalhePedido(wnumped) {
        let temp = [];
        pedidos.filter(pedido => pedido.numped == wnumped).map((item) => {
            temp.push({
                numped: item.numped,
                ordem: item.talcli,
                data: item.datped,
                valor: item.valven,
                status: item.status,
                datent: item.datent,
                numnot: item.numnot,
                page: "/main"
            })
        })
        setDadosPed(temp);

        Navigate('/DetPedido');
    }

    /*function AtualizaW() {
        const root = document.documentElement;
        root.style.setProperty('--width', props.largura);
        root.style.setProperty('--widthcontent', props.larguraitem);
    }*/


    function GetPedidos() {
        setLoading(true);

        let temp = [];
        let data = [];
        let datafim = [];

        api.get(`pedidos/ultimos/?cgccli=${cgccli}&qtdreg=${props.qtdreg}`)
            .then((response) => {
                if (!response.data.msg) {

                    temp = response.data;
                    temp.map((item) => {
                        if (data.indexOf(item.datped) < 0) {
                            data.push(
                                item.datped
                            )
                        }
                    })

                    data.map((item) => {
                        datafim.push({
                            datped: item
                        })
                    })

                    setDatas(datafim);
                    setPedidos(response.data);
                    setLoading(false);
                } else {
                    setLoading(false);
                    Alerta('Erro1', response.data.msg, 'error');
                }
            }).catch((erro) => {
                //setLoading(true);
                //Alerta('Erro!', 'Servidor sem resposta', 'error');
                setTimeout(function() {
                    window.location.reload(true);
                  }, 5000)
            })
    }



    useEffect(() => {
        GetPedidos();
    }, [])


    return (
        <div className={styled.appultimospedidos}>
            <div className={styled.frame99}>
                {isLoading == true ? <Loader /> : null}
                {datas.map((dat) => {

                    return (
                        <>
                            <div className={styled.appitem}>
                                <a>Solicitado em <span>{dat.datped}</span></a>
                                <div className={styled.appitemgrupo}>
                                    {pedidos.filter(pedido => pedido.datped == dat.datped).map((item) => {
                                        return (
                                            <div key={item.numped} onClick={() => DetalhePedido(item.numped)} className={styled.appitempedido}>

                                                <div className={styled.pedidocontent}>
                                                    <div className={styled.pedidocontent0}>
                                                        <a>Nº <span>{item.numped}</span></a>
                                                        <a>O.C {item.talcli}</a>
                                                    </div>
                                                    <div className={styled.pedidocontent1}>
                                                        <a>{item.valven.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</a>
                                                        <div className={styled.statusdiv}>
                                                            <div className={styled.tagstatus}>
                                                                {item.status == 'EM TRANSPORTE' ? <div className={styled.statustrans}></div> : null}
                                                                {item.status == 'PRODUZINDO' ? <div className={styled.statusprod}></div> : null}
                                                                {item.status == 'ENTREGUE' ? <div className={styled.statusentregue}></div> : null}
                                                                {item.status == 'PEDIDO RECEBIDO' ? <div className={styled.statusrecebido}></div> : null}
                                                                {item.status == 'EM ANALISE' ? <div className={styled.statusanalise}></div> : null}
                                                                <a>{item.status}</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </>
                    )
                })}


            </div>

        </div>

    )
}


export default ListaUltimosPedidos;